import { useLocale } from "./LocaleContext";
import { fr } from "./translations/fr";
import { en } from "./translations/en";

const translations = { fr, en } as const;

export const useTranslation = () => {
  const { locale } = useLocale();
  return translations[locale];
};
